(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('EmployeeCustomerSectorDialogController', EmployeeCustomerSectorDialogController);

    EmployeeCustomerSectorDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'EmployeeCustomerSector', 'Employee', 'CustomerSector', 'Sector'];

    function EmployeeCustomerSectorDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, EmployeeCustomerSector, Employee, CustomerSector, Sector) {
        var vm = this;
        vm.employeeCustomerSector = entity;
        vm.employees = Employee.query();
        vm.customersectors = CustomerSector.query();
        vm.sectors = Sector.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        var onSaveSuccess = function (result) {
            $scope.$emit('sigmasfApp:employeeCustomerSectorUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.employeeCustomerSector.id !== null) {
                EmployeeCustomerSector.update(vm.employeeCustomerSector, onSaveSuccess, onSaveError);
            } else {
                EmployeeCustomerSector.save(vm.employeeCustomerSector, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
    }
})();
